import { useAnchorWallet } from "@solana/wallet-adapter-react";
import {
  WalletModalProvider,
  WalletMultiButton,
} from "@solana/wallet-adapter-react-ui";
import React, { FC } from "react";
import permissionDenied from "../../assets/permissionDenied.svg";
import "./PermissionDenied.scss";

//TODO@milica-monke-merge: This component is only for monke
const PermissionDenied: FC<{ message: string; loading?: boolean }> = ({
  message,
  loading,
}) => {
  const wallet = useAnchorWallet();

  return (
    <WalletModalProvider>
      <div className="permission-denied">
        <img
          className={`${loading && "permission-denied__img-loading"}`}
          src={permissionDenied}
        />
        <h3>{message}</h3>
        {!wallet?.publicKey && (
          <WalletMultiButton className="permission-denied__wallet" />
        )}
      </div>
    </WalletModalProvider>
  );
};

export default PermissionDenied;
